import get from 'lodash/get'
import {fsaPayloadByKeys} from '../../../../actions/helpers'
import {RootState} from '../../../../store/types'
import {DeleteOrderItemsRequestBody} from '../../hooks/useDeleteOrderItems'

export const SET_REMOVE_ITEMS_REFUNDS = 'set remove items refunds'
export const setRemoveItemsRefunds = fsaPayloadByKeys(SET_REMOVE_ITEMS_REFUNDS, [
  'selectedItems',
  'isCancelingOrder',
])

export const getRemoveItemsData = (
  state: RootState,
): {selectedItems: DeleteOrderItemsRequestBody['order_items']; isCancelingOrder: boolean} =>
  get(state, 'userInteractions.removeItems', null)
